module.exports = "/assets/5dca03f456c09d483de253189a5835c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/W5.png
// module id = 3067
// module chunks = 0